//   "a_level_subject_tests": null,

export const SUBJECT_TESTING_TYPES = ['a_level'];
const isALevelSubjectTests = (type: string) => SUBJECT_TESTING_TYPES.includes(type);

interface StandardItem {
  type: string;
  subject: string;
  examination_board: string;
  level: string;
}

export default class SubjectTestsConverter {
  static is = isALevelSubjectTests;
  static isValid = (item: StandardItem) => {
    return Boolean(item.subject) || Boolean(item.examination_board) || Boolean(item.level);
  };

  static toArray(resume: Record<string, any>) {
    const items: StandardItem[] = [];
    SUBJECT_TESTING_TYPES.forEach((type) => {
      const subjectTests = resume[`${type}_subject_tests`] || [];
      subjectTests.forEach((subjectTest) => {
        const { subject, examination_board, level } = subjectTest;
        items.push({ type, subject, examination_board, level });
      });
    });
    return items;
  }

  static toValidArray(resume: Record<string, any>) {
    const items = this.toArray(resume);
    return items.filter(this.isValid);
  }

  static toObject(items: StandardItem[]) {
    const resume = {};
    items.forEach((item) => {
      const { type, subject, examination_board, level } = item;
      const subjectTests = resume[`${type}_subject_tests`] || [];
      subjectTests.push({
        subject: subject || '',
        examination_board: examination_board || '',
        level,
      });
      resume[`${type}_subject_tests`] = subjectTests;
    });
    return resume;
  }

  static defaults() {
    return {
      a_level_subject_tests: [],
    };
  }
}
